import styled from 'styled-components'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: flex;
	${textModels('text', 'l', '400')}
	margin-bottom: 8px;
	&:last-child {
		margin-bottom: 0px;
	}
`
export const Text = styled.div`
	color: ${themeObject.colors.grey[800]};
`
export const TextColor = styled.a`
	color: ${themeObject.colors.brand[500]};
`
